import { render, staticRenderFns } from "./DisputeResolutionAttachments.vue?vue&type=template&id=bfc22066&scoped=true&"
import script from "./DisputeResolutionAttachments.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionAttachments.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolutionAttachments.vue?vue&type=style&index=0&id=bfc22066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc22066",
  null
  
)

export default component.exports